<template>

    <div class="layout__padding-clear layout__width-80">

        <!--{{orders[0]}}-->

        <div class="">
            <CustomerOrdersSearch v-bind:searchParams="searchParams" v-bind:orders="orders" v-bind:view="view" v-bind:loading="loading"></CustomerOrdersSearch>
        </div>

        <!--{{this.orders[0]}}-->
        <div class="layout__width-100 layout__position-left">
        <el-table :data="orders" v-on:row-click="showOrderDetails" class="layout__padding-clear layout__height-600px layout__scrolling__right layout__margin__bottom-30" v-loading="loading">
            <el-table-column prop="orderId" label="Order Id">
            </el-table-column>
            <el-table-column prop="billDescription" label="Order Ref">
            </el-table-column>
            <el-table-column prop="status" label="Status">
            </el-table-column>
            <el-table-column prop="ordered" label="Created" :formatter="formatDateDDMMYYYY">
            </el-table-column>
            <el-table-column prop="billGrossTotal" label="Cost (GBP)" :formatter="returnCurrency">
            </el-table-column>
            <!-- todo a simple way to have a v-bind:href -->
            <!--<el-table-column label="Artwork" width="90" v-on:cell-click="event.stopPropagation()">-->
            <!--<template slot-scope="props">-->
            <!--<a v-bind:href="props.row.imageUrl" v-on:cell-click="event.stopPropagation()">-->
            <!--<div class="leftAlign" v-on:cell-click="event.stopPropagation()">-->
            <!--<el-button class="redButton" v-on:cell-click="event.stopPropagation()"><img class="column50 center"-->
            <!--src="../../public/images/download.png">-->
            <!--</el-button>-->
            <!--</div>-->
            <!--</a>-->
            <!--</template>-->
            <!--</el-table-column>-->

            <el-table-column label="Download Artwork">
                <template slot-scope="props">
                    <!--<a v-bind:href="props.row.imageUrl">-->
                    <div class="layout__padding-clear">
                            <img class="layout__width-20px layout__position-center" v-on:click="downloadPdf(props.row)" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download.png">
                    </div>
                    <!--</a>-->
                </template>
            </el-table-column>
        </el-table>
        </div>

        <div class="layout__padding-clear layout__width-60">
            <div class="layout__padding-20-0">
                <el-pagination class="layout__padding-clear"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="this.searchParams.currentPage"
                               :page-sizes="[20, 40, 60, 80, 100]"
                               :page-size="this.searchParams.pagination"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="this.resultsCount">
                </el-pagination>
            </div>
        </div>

        <!--<Pagination v-bind:orders="orders" v-bind:start="start" v-bind:end="end" v-bind:pagination="pagination"></Pagination>-->

    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import CustomerOrdersSearch from '../../components/search/CustomerOrdersSearch';
    import Pagination from "../../components/Pagination";
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {pagination} from '@/mixins/Pagination.js';

    export default {
        name: "OrderDetails",
        mixins: [axios, dataFormatter, pagination],
        components: {
            Pagination,
            CustomerOrdersSearch
        },
        data() {
            return {
                resultsCount: '',
                orders: [],
                loading: false,
                searchParams: {
                },
                view: 'PDFUpload'
            }
        },
        methods: {
            showOrderDetails(job) {

                this.$router.push({
                    name: '/orders/instant-print/details',
                    params: {
                        orderOverview: job
                    },
                    query: {
                        id: job.sourceId,
                    }
                })
            },
            downloadPdf(artwork) {

                console.log(artwork)


                const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfupload/Orders/GetSource/${artwork.orderFilename}`;

                console.log(url)
                event.stopPropagation();  

                Axios.get(url, { ...this.returnHeaderUsingToken(), responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data], {
                          type: response.headers['content-type'],
                        });
                        const link = document.createElement('a');

                        link.href = window.URL.createObjectURL(blob);
                        link.download = artwork.jobName;

                        link.click();

                        event.stopPropagation();
                    });

                event.stopPropagation();
            },
            resultsPerPage() {
                document.getElementById('getCustomerOrdersPagination').click()
            },
        },
    };
</script>